import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import type { DochazkaClenView, SynchronizaceResponse, UzivatelAktivita } from "../generated/models/AkceDochazka";

const BASE = "/api/admin/akce";

export const DochazkaServiceApi = {
    getDochazka: (akceId: number) =>
        handleRequest<DochazkaClenView[]>(() => axiosInstance.get(`${BASE}/${akceId}/dochazka`)),

    ulozDochazku: (akceId: number, zaznamy: { uzivatelId: number; pritomen: boolean }[]) =>
        handleRequest<void>(() => axiosInstance.put(`${BASE}/${akceId}/dochazka`, { zaznamy })),

    uzavrit: (akceId: number) =>
        handleRequest<SynchronizaceResponse>(() => axiosInstance.post(`${BASE}/${akceId}/dochazka/uzavrit`, {})),

    odemknout: (akceId: number) =>
        handleRequest<void>(() => axiosInstance.post(`${BASE}/${akceId}/dochazka/odemknout`, {})),

    aktivitaUzivatele: (uzivatelId: number, rok?: number) =>
        handleRequest<UzivatelAktivita>(() =>
            axiosInstance.get(`${BASE}/dochazka/uzivatel/${uzivatelId}`, { params: rok ? { rok } : {} })),
};

export default DochazkaServiceApi;
